type SearchParamsLike = {
  get(name: string): string | null;
};

function getWorkspaceRelativePath(pathname: string) {
  const [, maybeWorkspace, ...segments] = pathname.split('/');

  if (!maybeWorkspace) {
    return [];
  }

  return segments;
}

export function getAnalyticsRefPage({
  pathname,
  searchParams,
}: {
  pathname: string;
  searchParams?: SearchParamsLike | null;
}) {
  const segments = getWorkspaceRelativePath(pathname);
  const [firstSegment] = segments;

  if (firstSegment === 'dash') {
    return 'home';
  }

  if (firstSegment === 'identity') {
    const tab = searchParams?.get('tab');

    if (tab === 'card') {
      return 'card';
    }

    if (tab === 'qr-code') {
      return 'qr_code';
    }

    return 'member_details';
  }

  return firstSegment || 'unknown';
}
